
  import { RequiredConfigVariable } from '@/services/integrations/types';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { Button } from '@/ui/components/Button';
  import BaseStep, { BaseStepProperties, BASE_STEP_PROPS } from './BaseStep.vue';
  import { defineComponent, ref } from 'vue';

  interface SelectFolderStepProperties extends BaseStepProperties {
    configVariable: RequiredConfigVariable;
  }

  export default defineComponent<SelectFolderStepProperties>({
    components: {
      Button,
      BaseStep,
    },
    props: [...BASE_STEP_PROPS, 'configVariable'],

    setup(props) {
      const store = useIntegrationDetailsStore();
      const { key, pickList } = props.configVariable;

      const value = ref(store.getConfigVariable(key) as string|undefined);
      const submit = () => {
        if (!value.value) {
          return;
        }

        store.setConfigVariable(key, value.value);
        store.nextStep();
      };

      return {
        options: pickList,
        value,
        submit,
      };
    },
  });
